var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg019FaceProtection = function Svg019FaceProtection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165 422h182c8.276 0 15-6.724 15-15V211H150v196c0 8.276 6.724 15 15 15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 407c0 57.891 47.109 105 105 105h182c57.891 0 105-47.109 105-105V196C452 88.48 363.52 0 256 0S60 88.48 60 196zm120-286h152v30H180zm-60 60h272v226c0 24.814-20.186 45-45 45H165c-24.814 0-45-20.186-45-45zM0 181h30v150H0zM482 181h30v150h-30z"
  })));
};
export default Svg019FaceProtection;